import * as Yup from 'yup';

// const phoneRegExp =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const numberToString = (value) => {
  return !!value ? value?.toString() : "";
};

export const isRequiredString = (message?: any) => {
  const pincode1 = 'pincode';
  const pincode2 = 'pin code';
  const aadharnumber1 = 'aadhar number';
  const aadharnumber2 = 'aadhaar number';
  const phone1 = 'mobile number';
  const phone2 = 'phone number'
  const regex1 = new RegExp('\\b' + pincode1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex0 = new RegExp('\\b' + pincode2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex2 = new RegExp('\\b' + aadharnumber1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex3 = new RegExp('\\b' + aadharnumber2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex4 = new RegExp('\\b' + phone1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex5 = new RegExp('\\b' + phone2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  if (regex1.test(message?.toLowerCase()) || regex0.test(message?.toLowerCase())) {
    return Yup
      .string()
      .transform(numberToString) // Convert number to string
      .required(message)
      .matches(/^\d{6}$/, 'Invalid PIN code. It should be a 6-digit number.').test('no-empty-string', message, value => {
        return value.trim() !== '';
      })
  } else if(regex2.test(message?.toLowerCase()) || regex3.test(message?.toLowerCase())) {
    return Yup
    .string()
    .transform(numberToString) // Convert number to string
    .required(message)
    .matches(/^\d{12}$/, 'Invalid Aadhaar. It should be a 12-digit number.').test('no-empty-string', message, value => {
      return value.trim() !== '';
    })
  }  else if(regex4.test(message?.toLowerCase()) || regex5.test(message?.toLowerCase())) {
    return Yup
    .string()
    .transform(numberToString) // Convert number to string
    .required(message)
    .matches(/^\d{10}$/, 'Mobile Number. It should be a 10-digit number.').test('no-empty-string', message, value => {
      return value.trim() !== '';
    })
  } else {
    return Yup.string().required(message).test('no-empty-string', message, value => {
      return value.trim() !== '';
    });
  }
};

export const isRequiredNumber = (message?: string | any) => {
  const pincode1 = 'pincode';
  const pincode2 = 'pin code';
  const aadharnumber1 = 'aadhar number';
  const aadharnumber2 = 'aadhaar number';
  const phone1 = 'mobile number';
  const phone2 = 'phone number'
  const regex1 = new RegExp('\\b' + pincode1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex0 = new RegExp('\\b' + pincode2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex2 = new RegExp('\\b' + aadharnumber1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex3 = new RegExp('\\b' + aadharnumber2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex4 = new RegExp('\\b' + phone1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex5 = new RegExp('\\b' + phone2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  if (regex1.test(message?.toLowerCase()) || regex0.test(message?.toLowerCase())) {
    return Yup
      .string()
      .transform(numberToString) // Convert number to string
      .required(message)
      .matches(/^\d{6}$/, 'Invalid PIN code. It should be a 6-digit number.')
  } else if(regex2.test(message?.toLowerCase()) || regex3.test(message?.toLowerCase())) {
    return Yup
    .string()
    .transform(numberToString) // Convert number to string
    .required(message)
    .matches(/^\d{12}$/, 'Invalid Aadhaar. It should be a 12-digit number.')
  }  else if(regex4.test(message?.toLowerCase()) || regex5.test(message?.toLowerCase())) {
    return Yup
    .string()
    .transform(numberToString) // Convert number to string
    .required(message)
    .matches(/^\d{10}$/, 'Mobile Number. It should be a 10-digit number.')
  } else {
    return Yup.number().required(message);
  }
}

// export const isRequiredEmail = (message?: string) =>
//   Yup.string().email(message || 'Please input a valid email address').label("Email ID");

export const isRequiredEmail = (message?: string, isNotRequired?: boolean) => {
  if(isNotRequired) 
    return Yup.string().email(message || 'Please input a valid email address').label("Email ID");
  return Yup.string().email(message || 'Please input a valid email address').required('Email is required').label("Email ID");
}


export const isRequiredNumberGreaterThan0 = (
  requiredMessage?: string | any,
  constraintMessage?: string,
) => {
  const pincode1 = 'pincode';
  const pincode2 = 'pin code';
  const aadharnumber1 = 'aadhar number';
  const aadharnumber2 = 'aadhaar number';
  const phone1 = 'mobile number';
  const phone2 = 'phone number'
  const regex1 = new RegExp('\\b' + pincode1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex0 = new RegExp('\\b' + pincode2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex2 = new RegExp('\\b' + aadharnumber1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex3 = new RegExp('\\b' + aadharnumber2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex4 = new RegExp('\\b' + phone1.replace(/\s+/g, '\\s+') + '\\b', 'i');
  const regex5 = new RegExp('\\b' + phone2.replace(/\s+/g, '\\s+') + '\\b', 'i');
  if (regex1.test(requiredMessage?.toLowerCase()) || regex0.test(requiredMessage?.toLowerCase())) {
    return Yup
      .string()
      .transform(numberToString) // Convert number to string
      .required(requiredMessage)
      .matches(/^\d{6}$/, 'Invalid PIN code. It should be a 6-digit number.')
  } else if(regex2.test(requiredMessage?.toLowerCase()) || regex3.test(requiredMessage?.toLowerCase())) {
    return Yup
    .string()
    .transform(numberToString) // Convert number to string
    .required(requiredMessage)
    .matches(/^\d{12}$/, 'Invalid Aadhaar. It should be a 12-digit number.')
  } else {
    return Yup.number().min(1, constraintMessage).required(requiredMessage)
  }
};

export const isRequiredMobileNumber = (message?: string) =>
  Yup.string()
    .matches(/^[0-9]{10}$/, 'Invalid mobile number. Please enter a valid 10-digit mobile number')
    .required(message);